import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";
import * as idb from '../../../functions/databaseService/indexedDB';
import signOut from "../../../functions/userIdentity/signOut";


// Action Types
export const EDIT_COMMENT_SUCCESS = "EDIT_COMMENT_SUCCESS";
export const EDIT_COMMENT_ERROR = "EDIT_COMMENT_ERROR";

// Thunk Action Creator
export const editCommentOfTask = createAsyncThunk(
    "api/Task/editComment",
    async (json, { dispatch }) => {
        try {
        const online = navigator.onLine;

        if (online) {
            const response = await axios.put(
                `${import.meta.env.VITE_PUBLIC_DOMAIN}Task/editComment/${json.id}`,
                {
                    id: json.id,
                    CommentId: json.commentId,
                    Text: json.text
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

                //Check for response 
                //Store API result into indexed DB
            if (response.status == 200) {
                if (response.data === '') {
                    throw new Error("The last task has not been saved. Logging the user out");
                } else {
                    idb.storeTaskList(response.data.tasks || response.data);
                }
            }
            else {
                throw new Error("Error editing comment");
            }
                //get data from indexed DB
                //const taskListData = await idb.getTasks();

                //Dispatch Indexed DB instead of Axios result
                dispatch({
                    type: EDIT_COMMENT_SUCCESS,
                    payload: response.data
                });
            }
            else {
                //get data from indexed DB
                const taskListData = await idb.getTasks();
                if (taskListData) {
                    //Dispatch Indexed DB instead of Axios result
                    dispatch({
                        type: EDIT_COMMENT_SUCCESS,
                        payload: taskListData
                    });
                }
                else {
                    console.log("No tasks found in IndexedDB");
                }
            }
        }
        catch (error) {
            dispatch({ type: FIREBASE_GET_LATEST_TASK_FILE_ERROR, payload: error });
            await signOut();
        }
            //.then(response => {
            //    dispatch({
            //        type: EDIT_COMMENT_SUCCESS,
            //        payload: response.data,
            //    });
            //})
            //.catch(error => {
            //    dispatch({ type: EDIT_COMMENT_ERROR, payload: error });
            //});
    }
);
